import React from 'react';
import copy from 'copy-to-clipboard';
import { toast } from 'react-semantic-toasts';
import PropTypes from 'prop-types';
import { Loader } from '@playbookux/playbook-web-core';

import { config } from '../../../../config';

import {
  Button,
  Container,
  Content,
  Dialog,
  Header,
  Input,
  Row,
  LoaderContainer,
} from './styles';

const PasswordLinkModal = (props) => {
  const {
    resetPasswordToken,
    show,
    onClose,
    loading,
  } = props;

  const handleLinkCopy = (url) => {
    if (url) {
      copy(url);
      toast({
        description: 'Reset password link copied to the clipboard!',
        time: 800,
      });
    } else {
      toast({
        description: '',
        time: 1200,
      });
    }
  };

  return (
    <Container
      active={show}
      onClickOutside={onClose}
      page
    >
      <Dialog>
        <Header as="h1">
          Reset password link
        </Header>

        <Content>
          {loading ? (
            <LoaderContainer>
              <Loader data-loader="password-link-loader" />
            </LoaderContainer>
          ) : (
            <Row>
              <Input
                placeholder=""
                value={`${config.REACT_APP_COMPANY_PLATFORM_URI}/reset-password?token=${resetPasswordToken}`}
                disabled
              />
              <Button
                onClick={() => handleLinkCopy(`${config.REACT_APP_COMPANY_PLATFORM_URI}/reset-password?token=${resetPasswordToken}`)}
              >
                Copy
              </Button>
            </Row>
          )}
        </Content>
      </Dialog>
    </Container>
  );
};

PasswordLinkModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  resetPasswordToken: PropTypes.string.isRequired,
  show: PropTypes.bool,
  loading: PropTypes.bool,
};

PasswordLinkModal.defaultProps = {
  show: false,
  loading: false,
};

export default PasswordLinkModal;
